<ng-template #searchTab let-item="item">
  <a
    class="flex-1 cursor-pointer select-none border-b-2 px-[8px] pb-2 text-center"
    [ngClass]="item.active ? 'border-black' : 'border-transparent'"
    (click)="selectTab(item.name)">
    {{ item.title }}
    ({{ item.count > 99 ? "99+" : item.count }})</a
  >
</ng-template>
<ng-template #shipmentResult>
  @for (shipment of shipments().content; track shipment.item.shipmentReference; let shipmentIndex = $index) {
    <a
      class="mb-[8px] flex w-full cursor-pointer flex-col gap-y-2 rounded border border-zinc-200 p-4"
      data-testid="shipment-element-0"
      (click)="toggleSearch()"
      [routerLink]="['/shipments', shipment.item.shipmentId]">
      <header class="flex flex-nowrap items-center justify-between gap-[10px]">
        <div class="overflow-hidden">
          <p
            class="break-words font-bold text-[#14828D]"
            [innerHTML]="shipment.item.shipmentReference | highlight: query().q">
          </p>
        </div>
        <div class="flex self-start">
          <cs-status-badge [status]="shipment.item.status" />
        </div>
      </header>
      <main class="flex flex-col gap-y-2">
        @if (shipment.item.references.length) {
          <article>
            <p class="text-sm font-bold">Reference</p>
            @for (reference of shipment.item.references; track reference.type; let referenceIndex = $index) {
              <p class="break-words text-gray-500">
                <span class="font-semibold">{{ reference.type }}: </span>
                <span [innerHTML]="reference.value | highlight: query().q"> </span>
              </p>
            }
          </article>
        }
        @if (shipment.item.devices.length) {
          <article>
            <p class="text-sm font-bold">Device ID</p>
            @for (device of shipment.item.devices; track device.deviceId; let deviceIndex = $index) {
              <p class="text-gray-500" [innerHTML]="device.deviceNumber | highlight: query().q"> </p>
            }
          </article>
        }
        <p class="text-gray-500">
          @if (shipment.item.createdTimestamp) {
            Created: {{ shipment.item.createdTimestamp | formatDate }}
          } @else {
            Created: -
          }
        </p>
      </main>
    </a>
  } @empty {
    <div class="flex size-full flex-col items-center justify-center p-4">
      <cs-icon style="width: 64px; height: 64px" name="empty" />
      <p class="mt-4">No results found</p>
    </div>
  }
  @if (loadMoreFor().shipments) {
    <button
      kendoButton
      fillMode="clear"
      class="mb-[64px] flex w-full items-center justify-center gap-x-2 text-[#14828D] md:mb-4"
      data-testid="shipments-load-more-button"
      (click)="handleLoadMore()">
      @if (loadingStatus() === "loading-more") {
        <cs-icon
          id="search-load-more-spinner"
          class="flex size-[20px] animate-spin items-center justify-center"
          name="loadingSpinner"
          size="large"></cs-icon>
      } @else {
        <div class="flex">
          <cs-icon class="flex font-medium" name="add"></cs-icon>
        </div>
        <span class="font-medium">Load More</span>
      }
    </button>
  }
</ng-template>
<ng-template #dataSourceResult>
  @for (dataSource of dataSources().content; track $index) {
    <a
      class="mb-[8px] flex w-full flex-col gap-y-2 rounded border border-zinc-200 p-4"
      data-testid="data-source-element-0"
      (click)="toggleSearch()"
      [routerLink]="
        dataSource.item.type === 'DEVICE' ? ['/data-sources/devices'] : ['/data-sources/labels', dataSource.item.id]
      "
      [queryParams]="dataSource.item.type === 'DEVICE' ? { deviceNumber: dataSource.item.number } : null">
      <header class="flex flex-nowrap items-center justify-between">
        <div class="overflow-hidden">
          <p
            class="break-words font-semibold text-[#14828D]"
            [innerHTML]="dataSource.item.number | highlight: query().q">
          </p>
        </div>

        @if (dataSource.item.type === "DEVICE") {
          <cs-status-badge [status]="dataSource.item.status" />
        }
      </header>
      <main class="flex flex-col gap-y-2">
        <article>
          <p class="text-sm font-bold">Type</p>
          <p class="text-gray-500">{{ DATA_SOURCE_TYPES_DICTIONARY[dataSource.item.type] }}</p>
        </article>
      </main>
    </a>
  } @empty {
    <div class="flex size-full flex-col items-center justify-center p-4">
      <cs-icon style="width: 64px; height: 64px" name="empty" />
      <p class="mt-4">No results found</p>
    </div>
  }
  @if (loadMoreFor().dataSources) {
    <button
      kendoButton
      fillMode="clear"
      class="mb-[64px] flex w-full items-center justify-center gap-x-2 text-[#14828D] md:mb-4"
      (click)="handleLoadMore()">
      @if (loadingStatus() === "loading-more") {
        <cs-icon
          id="search-load-more-spinner"
          class="flex size-[20px] animate-spin items-center justify-center"
          name="loadingSpinner"
          size="large"></cs-icon>
      } @else {
        <div class="flex">
          <cs-icon class="flex font-medium" name="add"></cs-icon>
        </div>
        <span class="font-medium">Load More</span>
      }
    </button>
  }
</ng-template>
<ng-template #facilityResult>
  @for (facility of facilities().content; track $index) {
    <a
      class="mb-[8px] flex w-full cursor-pointer flex-col gap-y-2 rounded border border-zinc-200 p-4"
      data-testid="facility-element-0"
      (click)="toggleSearch()"
      [routerLink]="['/facilities', facility.item.facilityViewId]">
      <header class="flex flex-nowrap items-center gap-[10px]">
        <div class="overflow-hidden">
          <p class="break-words font-bold text-[#14828D]" [innerHTML]="facility.item.name | highlight: query().q"> </p>
        </div>
      </header>
      <main class="flex flex-col gap-y-2">
        @if (facility.item.address.length) {
          <article>
            <p class="text-sm font-bold">Address</p>
            <p class="text-gray-500" [innerHTML]="facility.item.address | highlight: query().q"></p>
          </article>
        }
        @if (facility.item.labels.length) {
          <article>
            <p class="text-sm font-bold">Labels</p>
            @for (label of facility.item.labels; track $index) {
              <p class="text-gray-500" [innerHTML]="label | highlight: query().q"></p>
            }
          </article>
        }
      </main>
    </a>
  } @empty {
    <div class="flex size-full flex-col items-center justify-center p-4">
      <cs-icon style="width: 64px; height: 64px" name="empty" />
      <p class="mt-4">No results found</p>
    </div>
  }
  @if (loadMoreFor().facilities) {
    <button
      kendoButton
      fillMode="clear"
      class="mb-[64px] flex w-full items-center justify-center gap-x-2 text-[#14828D] md:mb-4"
      (click)="handleLoadMore()">
      @if (loadingStatus() === "loading-more") {
        <cs-icon
          id="search-load-more-spinner"
          class="flex size-[20px] animate-spin items-center justify-center"
          name="loadingSpinner"
          size="large"></cs-icon>
      } @else {
        <div class="flex">
          <cs-icon class="flex font-medium" name="add"></cs-icon>
        </div>
        <span class="font-medium">Load More</span>
      }
    </button>
  }
</ng-template>
<div
  class="absolute left-0 top-0 z-10 w-full flex-col justify-center px-[3px] pt-[3px] lg:static lg:px-0 lg:pt-0"
  [ngClass]="{
    hidden: isMobileView() && !isSearchVisible(),
    flex: !isMobileView() || (isMobileView() && isSearchVisible()),
  }">
  <form class="relative" #search [formGroup]="searchForm">
    <kendo-textbox
      formControlName="queryInput"
      class="cs-universal-search pl-[6px]"
      placeholder="Search shipments, references, devices"
      [maxlength]="256"
      (keydown.enter)="onKeydownEnter($event)"
      [clearButton]="loadingStatus() !== 'loading'"
      data-testid="universal-search-input">
      <ng-template kendoPrefixTemplate>
        <cs-icon
          class="hidden lg:flex lg:size-[20px] lg:items-center lg:justify-center"
          name="universalSearch"></cs-icon>
        <button class="lg:hidden" kendoButton fillMode="flat" (click)="toggleSearch()">
          <cs-icon name="chevronLeft" class="flex size-[20px] items-center justify-center"></cs-icon>
        </button>
      </ng-template>
    </kendo-textbox>
    @if (loadingStatus() === "loading") {
      <div class="absolute right-0 top-0 mr-[30px] flex h-full items-center justify-end">
        <cs-icon
          class="flex size-[20px] animate-spin items-center justify-center"
          name="loadingSpinner"
          size="large"
          data-testid="universal-search-loading"></cs-icon>
      </div>
    }
  </form>
  @if (showPopup()) {
    <kendo-popup
      #popup
      [anchor]="search"
      class="mt-[2px] h-dvh w-full lg:mt-[3px] lg:max-h-[689px] lg:max-w-[465px]"
      data-testid="universal-search-popup">
      <section class="flex max-h-[calc(100vh-3rem)] min-h-[306px] flex-col lg:max-h-[calc(100vh-8rem)]">
        <header>
          <section class="px-[10px] pb-[24px] pt-[12px]">
            <span>{{ totalMatches() }} {{ totalMatches() !== 1 ? "results" : "result" }} for "{{ query().q }}"</span>
          </section>
          <nav class="mb-[16px] flex items-center" data-testid="universal-search-tabs">
            <ng-container
              *ngTemplateOutlet="
                searchTab;
                context: {
                  item: {
                    title: 'Shipments',
                    name: 'shipments',
                    count: shipments().totalElements,
                    active: tab() === 'shipments',
                  },
                }
              ">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="
                searchTab;
                context: {
                  item: {
                    title: 'Facilities',
                    name: 'facilities',
                    count: facilities().totalElements,
                    active: tab() === 'facilities',
                  },
                }
              ">
            </ng-container>
            <ng-container
              *ngTemplateOutlet="
                searchTab;
                context: {
                  item: {
                    title: 'Data Sources',
                    name: 'dataSources',
                    count: dataSources().totalElements,
                    active: tab() === 'dataSources',
                  },
                }
              ">
            </ng-container>
          </nav>
        </header>
        <main class="cs-universal-search-match relative h-full overflow-auto px-[8px] pb-10 md:pb-0">
          @if (tab() === "shipments") {
            <ng-container *ngTemplateOutlet="shipmentResult"></ng-container>
          }
          @if (tab() === "dataSources") {
            <ng-container *ngTemplateOutlet="dataSourceResult"></ng-container>
          }
          @if (tab() === "facilities") {
            <ng-container *ngTemplateOutlet="facilityResult"></ng-container>
          }
        </main>
      </section>
    </kendo-popup>
  }
</div>
